<script lang="ts">
	import { onMount } from 'svelte';
	import { format } from 'svelte-i18n';
	// Design system components
	import { Button, ListItem, Loader, Modal, PlainTable } from '@Shelly/shelly-design-system/index';
	// Helpers
	import {
		getSessionsInfo,
		type SessionEvents,
		type SessionInfo,
	} from 'src/helpers/xt1_helpers/ev_charger/ev_charger_session_info_helpers';
	import { dateFormat } from 'src/helpers/date_helper';
	import { getEventLogStatistics } from 'src/helpers/xt1_helpers/ev_charger/ev_charger_statistics_helpers';
	import LayerChartRenderer from 'src/components/Chart/LayerChart/LayerChartRenderer.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { ChartDataInterface } from 'src/types/Chart';

	export let device: Device, event: SessionEvents;

	let showModal: boolean = false;
	let chartData: ChartDataInterface = null;
	let sessionsInfo: SessionInfo[] = null;

	onMount(async () => {
		const statistics = await getEventLogStatistics(device, event);
		sessionsInfo = getSessionsInfo({ ...event, statistics });
		chartData = statistics.chartData;
	});
</script>

{#if chartData}
	<LayerChartRenderer
		chartData={{
			...chartData,
			height: 156,
			type: 'area',
		}}
	/>
	<Button
		variant="secondary"
		class="mt-s mb-s width-full"
		icon="fas fa-arrow-up-right-and-arrow-down-left-from-center"
		size="m"
		on:click={() => {
			showModal = true;
		}}
	>
		{$format('button_expand_view', {
			default: 'Expand view',
		})}
	</Button>
	<PlainTable class="width-full">
		<tbody>
			{#each [...sessionsInfo] as session}
				<tr>
					<th>{session.title}</th>
					<td class={session?.color ? session.color : ''}>{session.state}</td>
				</tr>
			{/each}
		</tbody>
	</PlainTable>
{:else}
	<div class="d-flex justify-content-center">
		<Loader />
	</div>
{/if}

{#if showModal}
	<Modal
		on:close={() => (showModal = false)}
		{showModal}
		backdropClose
		title={dateFormat(event.session_start, 'd-m-Y')}
	>
		<svelte:fragment slot="content">
			<LayerChartRenderer
				chartData={{
					...chartData,
					type: 'area',
				}}
			/>
			<div class="grid mt-l">
				{#each [...sessionsInfo] as session}
					<ListItem
						icon={session.icon}
						title={session.title}
						viewType="fullColored"
						progress={{ title: session.state, color: session.color }}
						listItemBgColor="--color-1"
					/>
				{/each}
			</div>
		</svelte:fragment>
	</Modal>
{/if}

<style>
	.grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
		grid-gap: var(--spacing-s);
	}
</style>
